import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=63af3ca0"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"
import style0 from "./Api.vue?vue&type=style&index=0&id=63af3ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports